// 
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

function setAppstleFeaturesListPostion () {
  const ftlistInterval = setInterval(()=>{
    document.querySelectorAll('abz-featured-appstle-widget').forEach(function (widget) {
        let featuresList = widget.querySelector('.appstle_tooltip_wrapper_static');
        let subscriptionOptionLabel = widget.querySelector('.appstle_input_wrapper:not(.appstle_onetime_block) label');
        if (!subscriptionOptionLabel || !featuresList) return;
  
        subscriptionOptionLabel && featuresList && subscriptionOptionLabel.append(featuresList);
        clearInterval(ftlistInterval);
        return;
    });
  },1)
}
// dom content loaded
document.addEventListener('DOMContentLoaded', function () {
  appstleInit();
  
  // appstle widget initialised event
  document.addEventListener('AppstleSubscription:SubscriptionWidget:widgetInitialised', function (e) {
   setAppstleFeaturesListPostion();
  });
});

// customElements.define('abz-featured-appstle-widget', class extends HTMLElement {
//   constructor() {
//     super();
//   }
//   connectedCallback() {
//     this.oneTimeContainer = document.getElementById('appstle-one-time-container');
//     this.oneTimeContainer.addEventListener('click', () => {
//       let input = this.querySelector('.appstle_onetime_block > [name="selling_plan"]');
//       input && (input.checked = true) ;
//       input && input.dispatchEvent(new Event('change'));
//     })
//   }

//   appendOneTimeInput() {
//     if (this.getAttribute('data-moved-onetime') === 'true') return;
//     this.oneTimeInput = this.querySelector('.appstle_input_wrapper.appstle_onetime_block');
//     if (this.oneTimeInput) {
//       this.oneTimeContainer.prepend(this.oneTimeInput);
//       this.setAttribute('data-moved-onetime', 'true');
//     }
//   }
// });

document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanSelected', function (e) {
  // document.querySelectorAll('abz-featured-appstle-widget').forEach(widget => widget.appendOneTimeInput());
  setAppstleFeaturesListPostion();
});



// aelami-shop
// $('.aelami-shop').owlCarousel({
//   margin: 15,
//   loop: true,
//   nav: false,
//   autoplay: true,
//   autoplayTimeout: 1000,
//   dots: false,
//   autoWidth: true,
//   smartSpeed: 500,
//   responsive: {
//     0: {
//       items: 2
//     },
//     600: {
//       items: 3
//     },
//     768: {
//       items: 4
//     },
//     1000: {
//       items: 5
//     },
//     1280: {
//       items: 6
//     },
//     1366: {
//       items: 7
//     },
//     1536: {
//       items: 8
//     }
//   }
// })


// Testimonials carousel
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[id^="Testimonials-"]').forEach(function (el) {
    new Splide(el, {
      type: 'loop',
      perPage: 3,
      perMove: 1,
      gap: 20,
      arrows: false,
      pagination: false,
      autoplay: true,
      interval: 3000,
      speed: 500,
      breakpoints: {
        1000: { perPage: 1 },
        567:  { perPage: 1 },
      },
    }).mount();
  });
});


// Smooth auto scroll slider for each instance
document.addEventListener('DOMContentLoaded', function () {
  // Select all elements with a dynamic ID that matches 'smoothscroll-{section.id}'
  document.querySelectorAll('[id^="smoothscroll"]').forEach(function (slider) {
    new Splide(slider, {
      type: 'loop',
      drag: 'free',
      focus: 'center',
      direction: slider.getAttribute('data-direction'),
      arrows: false,
      autoWidth: true,
      pagination: false,
      perPage: 4,
      autoScroll: {
        speed: 0,
      },
    }).mount(window.splide.Extensions);
  });
});

// Go back
function goBack() {
  window.history.back(); 
}

// Font style
document.addEventListener("DOMContentLoaded", function () {
  // Find element containing that exact title
  const elements = document.querySelectorAll("*:not(script):not(style)");

  elements.forEach(function (el) {
    if (
      el.childNodes.length === 1 &&
      el.textContent.includes("Team Us vs. Team Everyone Else!")
    ) {
      // Replace "vs" with span + line break
      el.innerHTML = el.innerHTML.replace(
        "vs.",
        '<span style="font-weight: normal;">vs.</span><br>'
      );
    }
  });
});

// smooth scroll
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('a[href="#smooth-offers"]').forEach(link => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const target = document.getElementById("smooth-offers");
      if (target) {
        const top = target.getBoundingClientRect().top + window.scrollY - 60;
        window.scrollTo({
          top: top,
          behavior: "smooth"
        });
      }
    });
  });
});


  document.addEventListener('DOMContentLoaded', function () {
    function updateAppstlePlanText() {
      const planLabels = document.querySelectorAll(
        '.appstle-selling-plan-name-wrapper.appstle-selling-plan-label-name'
      );

      planLabels.forEach(function(label) {
        const cancelText = label.querySelector('.appstle-cancel-text');
        label.childNodes.forEach(function(node) {
          if (node.nodeType === 3 && node.textContent.trim() !== '') {
            node.textContent = 'Autoship & Save';
          }
        });
      });
    }

    updateAppstlePlanText();

    const observer = new MutationObserver(function() {
      updateAppstlePlanText();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
